import {
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Zoom,
} from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';

import styles from './OptionsBoardStyles';

const AdvancedBoardTable = ({
  rows,
  changeBidAskMid,
  highestCallEdge,
  highestEdge,
  highestActual,
}) => {
  const { appReducer, optionChainReducer } = useSelector((state) => state);
  const { isMobile } = appReducer;
  const { bidAskMid, hideShading } = optionChainReducer;

  const topPosition = isMobile ? '50px' : '91px';
  return (
    <Table stickyHeader>
      <TableHead>
        <TableRow style={styles.tableRow}>
          <TableCell
            style={{
              ...styles.advancedStrikeHeaderCell,
              top: topPosition,
            }}
            className="sticky"
          >
            Strike
          </TableCell>
          <TableCell
            style={{ ...styles.tableHeaderCell, top: topPosition }}
            className="sticky"
          >
            <Select
              value={bidAskMid}
              onChange={changeBidAskMid}
              style={styles.premiumSelect}
              inputProps={{
                name: 'bidAskMid',
                id: 'bidAskMid',
              }}
            >
              <MenuItem key={0} value={'ask'}>
                Ask
              </MenuItem>
              <MenuItem key={1} value={'mid'}>
                Mid
              </MenuItem>
              <MenuItem key={2} value={'bid'}>
                Bid
              </MenuItem>
            </Select>
          </TableCell>
          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 700 }}
            placement="top"
            PopperProps={{
              style: styles.tooltip,
            }}
            // leaveDelay={1500}
            title="This is the option’s Probability of being ITM. It ranges from 0-100%."
          >
            <TableCell
              style={{ ...styles.tableHeaderCell, top: topPosition }}
              className="sticky"
            >
              ITM
            </TableCell>
          </Tooltip>
          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 700 }}
            placement="top"
            PopperProps={{
              style: styles.tooltip,
            }}
            // leaveDelay={1500}
            title="The Risk Reward Breakeven Price shows the market’s expected Stock Price AT EXPIRATION that equalizes the risk and reward of the option."
          >
            <TableCell
              style={{ ...styles.RRHeaderCell, top: topPosition }}
              className="sticky"
            >
              $ RR
            </TableCell>
          </Tooltip>

          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 700 }}
            placement="top"
            PopperProps={{
              style: styles.tooltip,
            }}
            // leaveDelay={1500}
            title="The Options Margin of Safety (“OMS”) measures the difference between your expectations (Target Stock Price) and the market’s expectations (RR$)."
          >
            <TableCell
              style={{ ...styles.greenHeaderCell, top: topPosition }}
              className="sticky"
            >
              OMS
            </TableCell>
          </Tooltip>

          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 700 }}
            placement="top"
            PopperProps={{
              style: styles.tooltip,
            }}
            // leaveDelay={1500}
            title="Edge% is the percentage return expected by buying the option given your Target Stock Price and the Probability of being ITM."
          >
            <TableCell
              style={{ ...styles.greenHeaderCell, top: topPosition }}
              className="sticky"
            >
              Edge
            </TableCell>
          </Tooltip>
          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 700 }}
            placement="top"
            PopperProps={{
              style: styles.tooltip,
            }}
            // leaveDelay={1500}
            title="This is the % return you’ll make at Expiration given your Target Stock Price."
          >
            <TableCell
              style={{ ...styles.greenHeaderCell, top: topPosition }}
              className="sticky"
            >
              Actual
            </TableCell>
          </Tooltip>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, index) => {
          const { itm, strike, premium, RR, OMS, edgePercent, actualPercent } =
            row;

          return (
            <TableRow
              key={index}
              style={
                !hideShading && (itm >= 0.4549 || itm <= 0.245)
                  ? styles.shadedRow
                  : styles.tableRow
              }
            >
              <TableCell
                style={
                  !hideShading && (itm >= 0.4549 || itm <= 0.245)
                    ? styles.shadedStrikeCell
                    : styles.strikeCell
                }
              >
                {strike.toFixed(2)}
              </TableCell>
              <TableCell
                style={
                  !hideShading && (itm >= 0.4549 || itm <= 0.245)
                    ? styles.shadedTableCell
                    : styles.tableCell
                }
              >
                {premium.toFixed(2)}
              </TableCell>
              <TableCell
                style={
                  !hideShading && (itm >= 0.4549 || itm <= 0.245)
                    ? styles.shadedTableCell
                    : styles.tableCell
                }
              >
                {(itm * 100).toFixed(0)}%
              </TableCell>
              <TableCell
                style={
                  !hideShading && (itm >= 0.4549 || itm <= 0.245)
                    ? styles.shadedRRCell
                    : styles.RRCell
                }
              >
                {!RR ? 'NA' : RR.toFixed(2)}
              </TableCell>
              <TableCell
                style={
                  !hideShading && (itm >= 0.4549 || itm <= 0.245)
                    ? styles.shadedGreenCell
                    : styles.greenTableCell
                }
              >
                {!OMS ? 'NA' : OMS.toFixed(2)}
              </TableCell>

              <TableCell
                style={
                  !hideShading && (itm >= 0.4549 || itm <= 0.245)
                    ? styles.shadedGreenCell
                    : styles.greenTableCell
                }
              >
                {!edgePercent
                  ? 'NA'
                  : (edgePercent * 100).toFixed(
                      edgePercent * 100 >= 1000
                        ? 0
                        : edgePercent * 100 >= 100
                        ? 1
                        : 2
                    )}
                {!edgePercent ? '' : '% '}
                {row.edgePercent === highestEdge.value &&
                  row.edgePercent !== 0 &&
                  highestActual.rowIndex - highestEdge.rowIndex !== 0 && (
                    <span style={styles.bigH}>H</span>
                  )}
              </TableCell>
              <TableCell
                style={
                  !hideShading && (itm >= 0.4549 || itm <= 0.245)
                    ? styles.shadedGreenCell
                    : styles.greenTableCell
                }
              >
                {!actualPercent
                  ? 'NA'
                  : (actualPercent * 100).toFixed(
                      actualPercent * 100 >= 1000
                        ? 0
                        : actualPercent * 100 >= 100
                        ? 1
                        : 2
                    )}
                {!actualPercent ? '' : '% '}
                {row.actualPercent === highestActual.value &&
                  row.actualPercent !== 0 &&
                  highestActual.rowIndex - highestEdge.rowIndex !== 0 && (
                    <span style={styles.bigH}>H</span>
                  )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default AdvancedBoardTable;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/AdvancedBoardTable.jsx